// extracted by mini-css-extract-plugin
export default {"ModalBackground":"ModalBase_ModalBackground__EE-6c","ModalBox":"ModalBase_ModalBox__-xVuP"};